import React from 'react'
import PropTypes from 'prop-types'
import styles from '@aytm/app/stats/page/comments/comments/styles/Sentiments.module.scss'
import classNames from 'classnames'
import { SENTIMENTS_ICON_HASH } from '@aytm/app/stats/page/comments/lib/constants'

const SentimentIcon = ({
  sentiment = 'None',
  className = null,
  iconClassName = null,
  style = {},
  iconStyle = {},
  ...props
}) => (
  <div
    className={classNames(styles[`background-sentiment-${sentiment}`], {
      [className]: Boolean(className)
    })}
    style={style}
    {...props}
  >
    <i
      className={classNames(
        `icon-aytmfd-sentiment-${SENTIMENTS_ICON_HASH[sentiment]}`,
        styles[`color-sentiment-${sentiment}`],
        {
          [iconClassName]: Boolean(className)
        }
      )}
      style={iconStyle}
    />
  </div>
)

SentimentIcon.propTypes = {
  sentiment: PropTypes.string,
  style: PropTypes.object,
  iconStyle: PropTypes.object,
  className: PropTypes.string,
  iconClassName: PropTypes.string
}

export default SentimentIcon
